import LegalPage from './LegalPage';

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-medium text-[#00163E] mb-3">{title}</h2>
      {children}
    </div>
  );
}

function P({ children }) {
  return <p className="mb-3">{children}</p>;
}

export default function CookiesPage() {
  return (
    <LegalPage title="Política de Cookies" pageTitle="Conadvy | Cookies">
      <p className="text-[#8A9BB1] text-xs mb-8">Última actualización: [FECHA]</p>

      <Section title="1. ¿Qué son las cookies?">
        <P>Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Permiten que el sitio recuerde sus acciones y preferencias durante un periodo de tiempo, para que no tenga que volver a configurarlas cada vez que regrese.</P>
      </Section>

      <Section title="2. ¿Qué cookies utiliza este sitio web?">
        <P>Conadvy utiliza <strong>únicamente cookies técnicas imprescindibles</strong> para el funcionamiento del sitio web. Estas cookies son estrictamente necesarias y no requieren consentimiento previo.</P>

        <div className="overflow-x-auto mb-4">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-[#00163E]/10">
                <th className="text-left py-3 pr-4 font-medium text-[#00163E]">Cookie</th>
                <th className="text-left py-3 pr-4 font-medium text-[#00163E]">Tipo</th>
                <th className="text-left py-3 pr-4 font-medium text-[#00163E]">Finalidad</th>
                <th className="text-left py-3 font-medium text-[#00163E]">Duración</th>
              </tr>
            </thead>
            <tbody className="text-[#00163E]/70">
              <tr className="border-b border-[#00163E]/5">
                <td className="py-3 pr-4 font-mono text-xs">cookie_consent</td>
                <td className="py-3 pr-4">Técnica</td>
                <td className="py-3 pr-4">Registra que el usuario ha aceptado la información sobre cookies</td>
                <td className="py-3">12 meses</td>
              </tr>
            </tbody>
          </table>
        </div>

        <P><strong>No utilizamos cookies de seguimiento, analítica, publicidad ni de terceros.</strong></P>
      </Section>

      <Section title="3. Cookies de terceros">
        <P>Actualmente, este sitio web no instala cookies de terceros. Si en el futuro se incorporasen herramientas de analítica u otros servicios que utilicen cookies no técnicas, se solicitará su consentimiento previo mediante un panel de configuración y se actualizará esta política.</P>
      </Section>

      <Section title="4. ¿Cómo puede gestionar las cookies?">
        <P>Puede configurar su navegador para rechazar todas las cookies o para que le avise cuando se instale una. Tenga en cuenta que la desactivación de las cookies técnicas puede afectar al funcionamiento del sitio web.</P>
        <P>Instrucciones por navegador:</P>
        <ul className="list-disc list-inside space-y-1.5 mb-3 ml-2">
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#C58C40] hover:underline">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-" target="_blank" rel="noopener noreferrer" className="text-[#C58C40] hover:underline">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#C58C40] hover:underline">Safari</a></li>
          <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#C58C40] hover:underline">Microsoft Edge</a></li>
        </ul>
      </Section>

      <Section title="5. Más información">
        <P>Para más información sobre cómo tratamos sus datos personales, consulte nuestra <a href="/privacidad" className="text-[#C58C40] hover:underline">Política de Privacidad</a>.</P>
        <P>Si tiene dudas sobre nuestra política de cookies, puede contactarnos en <a href="mailto:privacidad@conadvy.com" className="text-[#C58C40] hover:underline">privacidad@conadvy.com</a>.</P>
      </Section>
    </LegalPage>
  );
}
